import React from 'react';
import PropTypes from 'prop-types';
import payform from 'payform';

import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';

class RegularForm extends React.Component {
    static propTypes = {
        payment_processor: PropTypes.object.isRequired,
        t: PropTypes.func.isRequired,
    };

    constructor() {
        super();

        this.$number_input = null;
        this.$cvc_input = null;
        this.$expiry_input = null;

        this.state = {
            first_name: '',
            last_name: '',
            address_1: '',
            address_2: '',
            country: '',
            city: '',
            region: '',
            post_code: '',
        };
    }

    componentDidMount() {
        Mobi2Go.UI.bind(
            'invalidCreditCardDetailsWarning',
            this.invalidDetailsWarning
        );
    }

    componentWillUnmount() {
        Mobi2Go.UI.unbind(
            'invalidCreditCardDetailsWarning',
            this.invalidDetailsWarning
        );
    }

    invalidDetailsWarning = () => {
        const { t } = this.props;
        let id = 'invalid-card-details';
        let title = t('invalid_cc_details_title');
        let body = t('invalid_cc_details_body');

        if (!this.props.payment_processor.isCreditCardNumberValid()) {
            id = 'invalid-number';
            title = t('invalid_cc_number_title');
            body = t('invalid_cc_number_body');
        } else if (!this.props.payment_processor.isCreditCardExpiryValid()) {
            id = 'invalid-expiry';
            title = t('invalid_cc_expiry_title');
            body = t('invalid_cc_expiry_body');
        } else if (!this.props.payment_processor.isBillingDetailsValid()) {
            id = 'invalid-billing-details';
            title = t('invalid_cc_billing_details_title');
            body = t('invalid_cc_billing_details_body');
        }

        Mobi2Go.UI.centeredAlert({
            id,
            title,
            body,
            temp: true,
        });
    };

    onUpdateCreditCard = () => {
        const expiry = payform.parseCardExpiry(this.$expiry_input.val());

        const credit_card = {
            number: this.$number_input.val(),
            expiry_month: expiry.month || null,
            expiry_year: expiry.year || null,
            cvc: this.$cvc_input.val(),
        };

        if (this.props.payment_processor.shouldShowBillingDetails()) {
            credit_card.billing_details = {
                first_name: this.state.first_name,
                last_name: this.state.last_name,
                address_1: this.state.address_1,
                address_2: this.state.address_2,
                country: this.state.country,
                city: this.state.city,
                region: this.state.region,
                post_code: this.state.post_code,
            };
        }
        this.props.payment_processor.setCreditCard(credit_card);
    };

    render() {
        const { t } = this.props;
        return (
            <div className="m2g-order-confirmation-payment-cc-input-group">
                <input
                    className="m2g-order-confirmation-payment-cc-number-input m2g-input m2g-form-element--three-quarter-width inspectletIgnore"
                    type="tel"
                    data-credit-card-number
                    placeholder={t('card_number_placeholder')}
                    autoComplete="cc-number"
                    pattern="\d*"
                    noValidate
                    ref={number_input => {
                        if (number_input) payform.cardNumberInput(number_input);
                    }}
                    onChange={this.onUpdateCreditCard}
                />
                <input
                    className="m2g-order-confirmation-payment-cc-cvc-input m2g-input m2g-form-element--one-quarter-width inspectletIgnore"
                    type="tel"
                    data-credit-card-cvc
                    placeholder={t('cvc_placeholder')}
                    autoComplete="off"
                    ref={cvc_input => {
                        if (cvc_input) payform.cvcInput(cvc_input);
                    }}
                    onChange={this.onUpdateCreditCard}
                />
                <input
                    className="m2g-order-confirmation-payment-cc-expiry-input m2g-input m2g-form-element--half-width inspectletIgnore"
                    type="tel"
                    data-credit-card-expiry
                    placeholder={t('expiry_date_placeholder')}
                    ref={expiry_input => {
                        if (expiry_input) payform.expiryInput(expiry_input);
                    }}
                    onChange={this.onUpdateCreditCard}
                />

                {this.props.payment_processor.shouldShowBillingDetails() && (
                    <div className="m2g-order-confirmation-payment-cc-billing">
                        <div className="m2g-order-confirmation-payment-cc-form-title m2g-title-text">
                            {t('billing_details')}
                        </div>
                        <div className="m2g-order-confirmation-payment-cc-billing-input-group">
                            <input
                                className="m2g-order-confirmation-payment-cc-billing-first-name-input m2g-input m2g-form-element--half-width inspectletIgnore"
                                type="text"
                                data-credit-card-billing-first-name
                                placeholder={t('first_name_placeholder')}
                                value={this.state.first_name}
                                onChange={e =>
                                    this.setState(
                                        { first_name: e.target.value },
                                        this.onUpdateCreditCard
                                    )
                                }
                            />
                            <input
                                className="m2g-order-confirmation-payment-cc-billing-last-name-input m2g-input m2g-form-element--half-width inspectletIgnore"
                                type="text"
                                data-credit-card-billing-last-name
                                placeholder={t('last_name_placeholder')}
                                value={this.state.last_name}
                                onChange={e =>
                                    this.setState(
                                        { last_name: e.target.value },
                                        this.onUpdateCreditCard
                                    )
                                }
                            />
                            <input
                                className="m2g-order-confirmation-payment-cc-billing-address1-input m2g-input m2g-form-element--full-width inspectletIgnore"
                                type="text"
                                data-credit-card-billing-address-1
                                placeholder={t('address_1_placeholder')}
                                value={this.state.address_1}
                                onChange={e =>
                                    this.setState(
                                        { address_1: e.target.value },
                                        this.onUpdateCreditCard
                                    )
                                }
                            />
                            <input
                                className="m2g-order-confirmation-payment-cc-billing-address2-input m2g-input m2g-form-element--full-width inspectletIgnore"
                                type="text"
                                data-credit-card-billing-address-2
                                placeholder={t('address_2_placeholder')}
                                value={this.state.address_2}
                                onChange={e =>
                                    this.setState(
                                        { address_2: e.target.value },
                                        this.onUpdateCreditCard
                                    )
                                }
                            />
                            <input
                                className="m2g-order-confirmation-payment-cc-billing-country-input m2g-input m2g-form-element--full-width inspectletIgnore"
                                type="text"
                                data-credit-card-billing-country
                                placeholder={t('country_placeholder')}
                                value={this.state.country}
                                onChange={e =>
                                    this.setState(
                                        { country: e.target.value },
                                        this.onUpdateCreditCard
                                    )
                                }
                            />
                            <input
                                className="m2g-order-confirmation-payment-cc-billing-city-input m2g-input m2g-form-element--half-width inspectletIgnore"
                                type="text"
                                data-credit-card-billing-city
                                placeholder={t('city_placeholder')}
                                value={this.state.city}
                                onChange={e =>
                                    this.setState(
                                        { city: e.target.value },
                                        this.onUpdateCreditCard
                                    )
                                }
                            />
                            <input
                                className="m2g-order-confirmation-payment-cc-billing-region-input m2g-input m2g-form-element--half-width inspectletIgnore"
                                type="text"
                                data-credit-card-billing-region
                                placeholder={t('state_placeholder')}
                                value={this.state.region}
                                onChange={e =>
                                    this.setState(
                                        { region: e.target.value },
                                        this.onUpdateCreditCard
                                    )
                                }
                            />
                            <input
                                className="m2g-order-confirmation-payment-cc-billing-postcode-input m2g-input m2g-form-element--half-width inspectletIgnore"
                                type="text"
                                data-credit-card-billing-postcode
                                placeholder={t('post_code_placeholder')}
                                value={this.state.post_code}
                                onChange={e =>
                                    this.setState(
                                        { post_code: e.target.value },
                                        this.onUpdateCreditCard
                                    )
                                }
                            />
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default forwardRefWithTranslation('order.confirmation')(RegularForm);
